import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';
@Injectable()
export class LanguageService {
  invokeEvent: Subject<any> = new Subject(); 

  languageChanged() { 
    this.invokeEvent.next('changed')      
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/language.service.ts